import Vue from 'vue'
import Router from 'vue-router'
import store from '@/store'

import Login from '@/views/Login'
import Main from '@/views/Main'


Vue.use(Router)

const ifNotAuthenticated = (to, from, next) => {
  if (!store.getters.isAuthenticated) {
    next()
    return
  }
  next('/')
}

// Просто авторизован
const ifAuthenticated = (to, from, next) => {
  if (store.getters.isAuthenticated) {
    next()
    return
  }
  next('/login')
}

export default new Router({
  mode: 'history',
  routes: [
    {
      path: '/',
      name: 'home',
      beforeEnter: ifAuthenticated,
      component: Main
    },
    {
      path: '/login',
      name: 'login',
      beforeEnter: ifNotAuthenticated,
      component: Login,
      meta: { layout: 'auth-layout' }
    },
    {
      path: '*',
      name: 'not-found',
      beforeEnter: ifAuthenticated,
      component: () => import('@/views/PageNotFound.vue')
    }
  ]
})
